import { PATHS } from '@belong/common';
import classNames from 'classnames/bind';
import Button from 'components/Button/Button';
import { BUTTON_TYPES } from 'components/Button/buttonTypes';
import styles from './AgreeToTermsFooter.module.css';

const cx = classNames.bind(styles);

const AgreeToTermsFooter = (
  <div className={cx('agree-to-terms')}>
    By continuing, I agree to Belong’s
    <br />
    <div className={cx('second-line')}>
      <Button
        target="_blank"
        to={{ pathname: PATHS.PRIVACY_POLICY }}
        className={cx('agree-to-terms-bold')}
        buttonType={BUTTON_TYPES.TEXT}
      >
        PRIVACY POLICY
      </Button>
      and
      <Button
        to={{ pathname: PATHS.TERMS }}
        target="_blank"
        className={cx('agree-to-terms-bold')}
        buttonType={BUTTON_TYPES.TEXT}
      >
        TERMS OF SERVICE
      </Button>
    </div>
  </div>
);

export default AgreeToTermsFooter;
